import React, { memo, useRef } from 'react';
import classNames from 'classnames/bind';
import { useComplexFilter } from "./hooks/useComplexFilter";
import { Button } from "../../Button";
import { sizes, themes } from "../../Button/constants";
import Scrollbar from "../../Scrollbar";
import { defaultPropObject } from "../../constants";
import { Customize } from "../../icons";
import { ButtonBase } from "../../internal/ButtonBase";
import { ClickOutside } from "../../internal/ClickOutside";
import noop from "../../utils/noop";
import { ActiveFilters, Filters } from './components';
import styles from './ComplexFilterCanary.css';
var cx = classNames.bind(styles);
export var ComplexFilterCanary = /*#__PURE__*/memo(function (_ref) {
  var filterList = _ref.filterList,
      onAccept = _ref.onAccept,
      onReset = _ref.onReset,
      _ref$onClearActiveFil = _ref.onClearActiveFilter,
      onClearActiveFilter = _ref$onClearActiveFil === void 0 ? noop : _ref$onClearActiveFil,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes;
  var toggleRef = useRef();

  var _useComplexFilter = useComplexFilter({
    filterList: filterList,
    onAccept: onAccept,
    onClearActiveFilter: onClearActiveFilter
  }),
      initialState = _useComplexFilter.initialState,
      activeFilters = _useComplexFilter.activeFilters,
      isOpen = _useComplexFilter.isOpen,
      handleChange = _useComplexFilter.handleChange,
      handleAccept = _useComplexFilter.handleAccept,
      handleToggle = _useComplexFilter.handleToggle,
      handleCloseBody = _useComplexFilter.handleCloseBody,
      handleClearActiveFilter = _useComplexFilter.handleClearActiveFilter;

  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('controls')
  }, /*#__PURE__*/React.createElement(Scrollbar, {
    className: cx('scrollbar')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('active-filters', classes.activeFilter)
  }, /*#__PURE__*/React.createElement(ActiveFilters, {
    activeFilters: activeFilters,
    onClear: handleClearActiveFilter
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('filter-wrapper')
  }, /*#__PURE__*/React.createElement(ButtonBase, {
    ref: toggleRef,
    onClick: handleToggle,
    className: cx(classes.filterButton)
  }, /*#__PURE__*/React.createElement(Customize, {
    color: "N300"
  })), /*#__PURE__*/React.createElement(ClickOutside, {
    ignoreRefs: [toggleRef],
    onClickOutside: handleCloseBody,
    className: cx('click-outside')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('filter-body', {
      opened: isOpen
    }, classes.filterBody)
  }, /*#__PURE__*/React.createElement(Filters, {
    filterList: initialState,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('buttons')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onReset,
    block: true,
    theme: themes.secondary,
    size: sizes.small
  }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleAccept,
    block: true,
    theme: themes.b2c,
    size: sizes.small,
    classes: {
      root: cx('margin-button')
    }
  }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C")))))));
});
export default ComplexFilterCanary;